import { render, staticRenderFns } from "./ListMemberships.vue?vue&type=template&id=0540b731&scoped=true"
import script from "./ListMemberships.vue?vue&type=script&lang=js"
export * from "./ListMemberships.vue?vue&type=script&lang=js"
import style0 from "./ListMemberships.vue?vue&type=style&index=0&id=0540b731&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0540b731",
  null
  
)

export default component.exports